<mat-card appearance="outlined" class="col-12" style="float: left">
  <h4>Scout Packets: @if (scout) {
    <a (click)="navigateToScout(scout)">{{scout.assetName}}</a>
  }</h4>
  <mat-form-field appearance="fill" style="float: right" class="col-6">
    <mat-label>{{selectedDate}}</mat-label>
    <mat-date-range-input (touchUi)="(true)" [formGroup]="range" [rangePicker]="picker">
      <input matStartDate [min]="minDate" formControlName="start" placeholder="Start date"
        (dateChange)="changeEvent($event)" />
      <input matEndDate [max]="maxDate" formControlName="end" placeholder="End date"
        (dateChange)="changeEndEvent($event)" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
  @if (range.controls.start.hasError('matStartDateInvalid')) {
    <mat-error>Invalid start date</mat-error>
  }
  @if (range.controls.end.hasError('matEndDateInvalid')) {
    <mat-error>Invalid end date</mat-error>
  }
  @if (scout) {
    <mat-card appearance="outlined" class="col-6" style="float: right">
      <mat-select>
        <mat-form-field>
          <mat-select matInput placeholder="Select Scout" required [(ngModel)]="scout" name="scout">
            @for (s of availableScouts; track s) {
              <mat-option [value]="s" (click)="scoutSelect(s)">
                {{ s.assetName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-select>
      <p class="name" style="margin: 0px">
        {{ selectedDate }}
      </p>
      <!-- <p class="designation" style="margin: 0px">
      Name: {{ scout.assetName }}
    </p> -->
    <p class="designation-normal" style="margin: 0px">
      Customer: {{ scout.customerName }}
    </p>
    <p class="designation-normal" style="margin: 0px">
      Last Payload: {{ lastPayloadDate }}
    </p>
  </mat-card>
}
</mat-card>
@if (scout) {
  <mat-card appearance="outlined" class="col-12" style="float: left">
    <div class="col-3" style="float: left">
      <p class="text label-text margin none">
        Expected: {{ scout.expectedPacketCount.toString() }}
      </p>
    </div>
    <div class="col-3" style="float: left">
      <p class="text label-text margin none">
        Failed: {{ scout.failedPacketCount.toString() }}
      </p>
    </div>
    <div class="col-3" style="float: left">
      <p class="text label-text margin none">
        Successful: {{ scout.successfulPacketCount.toString() }}
      </p>
    </div>
    @if (scout) {
      <div class="col-3" style="float: left">
        @if (scout.percentage > 75) {
          <p class="text label-text margin none s-text">
            {{scout.percentage}}%
          </p>
        } @else {
          <p class="text label-text margin none e-text">
            {{scout.percentage}}%
          </p>
        }
      </div>
    }
    <br>
      <app-health-percentage-bar [total]="scout.totalPacketCount" [successful]="scout.successfulPacketCount"
        [failed]="scout.failedPacketCount">
      </app-health-percentage-bar>
    </mat-card>
  }
  <div>
    <figure class="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12" style="float: left" id="pie">
    </figure>
  </div>